import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import * as PIXI from "pixi.js";
import { GameStyle } from "../style/GameStyle";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { AbstractSpinsRemainingProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractSpinsRemainingProperties";
import { PawnAssetStyle } from "../style/PawnAssetStyle";
import { GameTextUtil } from "../../../utils/GameTextUtils";
/**
 * SpinsRemainingProperties.ts
 */
export class GameSpinsRemainingProperties extends AbstractSpinsRemainingProperties {
    constructor() {
        super();
        const counterPosition = new PIXI.Point(0, 0);
        const counterSize = new PIXI.Point(260, 120);
        this.backgroundProperties = new SpriteProperties(PawnAssetStyle.SpinsRemaining.landscape, GameStyle.MODULE, new PIXI.Point(0, 0), new PIXI.Point(1, 1), new PIXI.Point(0.5, 0.5));
        this.backgroundPurchaseProperties = this.backgroundFreeProperties = this.backgroundProperties;
        this.standardProperties = new TextFieldProperties(FontStyle.STANDARD_SPINS_REMAINING, counterPosition.clone(), undefined, ControlConstants.CENTER, ControlConstants.CENTER, counterSize.clone());
        this.standardInactiveProperties = new TextFieldProperties(FontStyle.STANDARD_SPINS_REMAINING, counterPosition.clone(), undefined, ControlConstants.CENTER, ControlConstants.CENTER, counterSize.clone());
        this.purchaseProperties = new TextFieldProperties(FontStyle.PURCHASE_SPINS_REMAINING, counterPosition.clone(), undefined, ControlConstants.CENTER, ControlConstants.CENTER, counterSize.clone());
        this.standardProperties.fontProperties.trim = this.standardInactiveProperties.fontProperties.trim = this.purchaseProperties.fontProperties.trim = true;
        this.updateTweenProperties = {
            duration: 0,
            scale: 1,
        };
        [this.standardProperties, this.standardInactiveProperties, this.purchaseProperties].forEach((properties) => {
            GameTextUtil.centerProperties(properties);
        });
    }
    equals(other) {
        return false;
    }
}
//# sourceMappingURL=GameSpinsRemainingProperties.js.map